import moment from 'moment-timezone';

import Abstract from 'classes/Abstract.js';
import User from 'classes/User.js';

class SystemEventClass {

    id = null;
    user = null;
    title = null;
    alt_title = null;
    date = null;
    action = null;
    props = null;
    target = null;


    constructor() {
        return this;
    }

    create = (props = {}) => {
        this.id = props.id;
        this.user = props.user ? User.create(props.user) : null;
        this.title = props.title;
        this.alt_title = props.alt_title;
        this.action = props.action;
        this.props = props.props;
        this.target = Abstract.create({
            type: props.target.type,
            object: props.target.object
        });

        // determine if date is utc or america/chicago
        // utc was used after lifewipe was migrated to a distributed server stack
        if(props.date) {
            let date = moment(props.date);
            if(moment(props.date) < moment('2022-12-22')) {
                this.date = moment(props.date);
            } else {
                this.date = moment.utc(props.date).local();
            }
        }
        return this;
    }
}

const actions = {
    create: 1,
    update: 2,
    delete: 3,
    warning: 4,
    note: 5
}

export default {
    create: props => new SystemEventClass().create(props),
    actions: actions,
}
